import { render } from "./AudioStylePanel.vue?vue&type=template&id=96b6ec3c&scoped=true&ts=true"
import script from "./AudioStylePanel.vue?vue&type=script&lang=ts"
export * from "./AudioStylePanel.vue?vue&type=script&lang=ts"

import "./AudioStylePanel.vue?vue&type=style&index=0&id=96b6ec3c&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b6ec3c"]])

export default __exports__